import { action, observable, reaction } from 'mobx';
import { mobileBreakpoint } from 'config';
import MobxState from './abstract/MobxState';

const isMobile = () => window.screen.width < mobileBreakpoint;

class UIState extends MobxState {
  isSideBarClosed = isMobile();

  isMobile = isMobile();

  handleResize() {
    this.isMobile = isMobile();
  }

  init() {
    super.init();
    this.reactions_.push(
      reaction(
        () => this.isMobile,
        (isMobile) => this.handleIsMobile_(isMobile)
      )
    );
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  handleIsMobile_(isMobile) {
    if (isMobile && !this.isSideBarClosed) {
      this.isSideBarClosed = true;
    }
  }

  destroy(states) {
    window.removeEventListener('resize', this.handleResize);
    this.isInitialized = false;
  }

  toggleSideBar() {
    this.isSideBarClosed = !this.isSideBarClosed;
  }

  setIsSideBarClosed(v) {
    this.isSideBarClosed = v;
  }
}

UIState.annotations = {
  ...MobxState.annotations,
  isSideBarClosed: observable.ref,
  isMobile: observable.ref,
  handleResize: action,
  toggleSideBar: action,
  setIsSideBarClosed: action,
  handleIsMobile_: action,
};

export default UIState;
